import { render, staticRenderFns } from "./TutorViewUserPlanCard.vue?vue&type=template&id=5bc7c650&"
import script from "./TutorViewUserPlanCard.vue?vue&type=script&lang=js&"
export * from "./TutorViewUserPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorViewUserPlanCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports